export default __webpack_public_path__ + "static/media/devX_infra_logo.cbdb7064.svg";